import { render, staticRenderFns } from "./EventStats.vue?vue&type=template&id=13a2c61b&scoped=true&"
import script from "./EventStats.vue?vue&type=script&lang=js&"
export * from "./EventStats.vue?vue&type=script&lang=js&"
import style0 from "./EventStats.vue?vue&type=style&index=0&id=13a2c61b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2c61b",
  null
  
)

export default component.exports